import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import JobTitlesTable from '../../components/jobTitles/JobTitlesTable';

const JobTitles = () => (
    <WrapperSection>
        <GlobalBreadcrumbs />
        <JobTitlesTable />
    </WrapperSection>
);

export default JobTitles;
